import React, { useState } from "react";
import {
    Container,
    Card,
    CardBody,
    Alert,
    Button,
    Label,
    Input,
    Form,
    FormFeedback,
} from "reactstrap";
import { useNavigate } from "react-router-dom";

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";

const UserAdd = () => {

    // Meta title
    document.title = "User Add | infuseone - Admin";

    const [status, setStatus] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const [name, setName] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [password, setPassword] = useState("");
    const [passwordLength, setPasswordLength] = useState(12);
    const [passwordMSG, setPasswordMSG] = useState();
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [getdesignation, setDesignation] = useState('');
    const [getQualification, setQualification] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [errorimage, setErrorimage] = useState(false);
    // Toggle user status
    const handleStatusChange = () => setStatus(!status);

    // Image preview handler
    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setPreviewImage(reader.result);
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const fileType = file.type;
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

            if (validImageTypes.includes(fileType)) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewImage(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                setErrorimage('Please upload a valid image.');
                return;
                // alert('Please upload a valid image file.');
            }
        }
    };

    // Form submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            username: e.target.username.value,
            name: e.target.name.value,
            email: e.target.email.value,
            phone_number: e.target.phone_number.value,
            password: e.target.password.value,
            profile_image: previewImage,
            designation: e.target.designation.value,
            qualification: e.target.qualification.value,
            is_active: status ? '1' : '0',
        };
        // setLoading(true);
        try {
            const response = await UserService.AddUser(formData).json();

            if (response.status) {
                setSuccess(response.message);
                navigate('/user-list');
                setErrorimage('');
                // setLoading(false);
            } else {
                setError(response.errors);
            }
        } catch (error) {
            console.error(error);
            setError('Something went wrong');
        }
    };

    const handleNameChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setName(newValue);
        }
    };

    const handlePhoneNumberChange = (e) => {
        const newValue = e.target.value;
        if (/^\d{0,12}$/.test(newValue)) {
            setPhoneNumber(newValue);
        }
    };

    const generatePassword = () => {

        let charset = "";
        let newPassword = "";

        charset += "!@#$%^&*()";
        charset += "0123456789";
        charset += "abcdefghijklmnopqrstuvwxyz";
        charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

        for (let i = 0; i < passwordLength; i++) {
            newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
        }

        setPassword(newPassword);
        setPasswordMSG('');

    };

    const copyToClipboard = () => {
        if (password.trim() === '') {
            setPasswordMSG('');
        } else {
            navigator.clipboard.writeText(password);
            setPasswordMSG('Password copied!');
        }
    };

    const previewPassword = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const handleDesignationChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setDesignation(newValue);
        }
    };

    const handleQualificationChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setQualification(newValue);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Add New User" />
                    {isLoading ? <Spinners setLoading={setLoading} /> :
                        <Card className="commonboxform">
                            <CardBody>
                                {success && (
                                    <Alert color="success" style={{ marginTop: "13px" }}>
                                        {success}
                                    </Alert>
                                )}
                                {error.general && (
                                    <Alert color="danger" style={{ marginTop: "13px" }}>
                                        {error.general}
                                    </Alert>
                                )}

                                {/* <h4 className="card-title mb-4">Add New User</h4> */}

                                <Form className="form-horizontal" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <div className="mb-3">
                                            <Label className="form-label">Username <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="username"
                                                name="username"
                                                placeholder="Enter username"
                                            />
                                            {error.username && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.username[0]}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Name <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                placeholder="Enter name"
                                                value={name}
                                                onChange={handleNameChange}
                                            />
                                            {error.name && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.name[0]}</FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Email <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                name="email"
                                                placeholder="Enter email"
                                            />
                                            {error.email && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.email[0]}</FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Phone Number <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="phone_number"
                                                name="phone_number"
                                                placeholder="Enter phone number"
                                                onChange={handlePhoneNumberChange}
                                                value={phoneNumber}
                                            />
                                            {error.phone_number && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.phone_number[0]}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Designation <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="designation"
                                                name="designation"
                                                placeholder="Enter Designation"
                                                value={getdesignation}
                                                onChange={handleDesignationChange}
                                            />
                                            {error.designation && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.designation[0]}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Qualification <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="qualification"
                                                name="qualification"
                                                placeholder="Enter Qualification"
                                                value={getQualification}
                                                onChange={handleQualificationChange}
                                            />
                                            {error.qualification && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.qualification[0]}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Password <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <div className="d-flex gap-3">
                                                <Input
                                                    type={isPasswordVisible ? 'text' : 'password'}
                                                    className="form-control"
                                                    id="password"
                                                    name="password"
                                                    placeholder="Enter Password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    invalid={!!error?.password}
                                                />
                                                {isPasswordVisible ?
                                                    <Button type="button" color="secondary" onClick={previewPassword} title="Show" >
                                                        <i className='bx bx-show'></i>
                                                    </Button>
                                                    :
                                                    <Button type="button" color="secondary" onClick={previewPassword} title="Hide" >
                                                        <i className='bx bx-hide'></i>
                                                    </Button>
                                                }
                                                <Button type="button" color="secondary" onClick={generatePassword} title="Generate">
                                                    <i className='bx bx-revision'></i>
                                                </Button>
                                                <Button type="button" color="info" onClick={copyToClipboard} title="Copy">
                                                    <i className='bx bx-copy-alt'></i>
                                                </Button>
                                            </div>
                                            {passwordMSG && (
                                                <FormFeedback type="valid" className="text-success" style={{ display: 'block' }}>{passwordMSG}</FormFeedback>
                                            )}
                                            {error.password && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.password[0]}</FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Profile Image <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            {previewImage && (
                                                <div className="mb-3 text-left">
                                                    <img
                                                        src={previewImage}
                                                        alt="Profile Preview"
                                                        className="img-fluid"
                                                        style={{ width: '100px', height: '60px', objectFit: 'cover' }}
                                                    />
                                                </div>
                                            )}
                                            <Input
                                                type="file"
                                                className="form-control"
                                                id="profile_image"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            {error.profile_image && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.profile_image[0]}</FormFeedback>
                                            )}
                                            {errorimage && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{errorimage}</FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Status</Label>
                                            <div className="form-check form-switch form-switch-lg mb-3">
                                                <Input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizelg"
                                                    name="status"
                                                    defaultChecked={status}
                                                    onChange={handleStatusChange}
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    htmlFor="customSwitchsizelg"
                                                >
                                                    {status ? 'Active' : 'Inactive'}
                                                </Label>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="text-left mt-4">
                                        <Button type="submit" color="secondary">
                                            Submit
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    }
                </Container>
            </div>
        </React.Fragment >
    );
};

export default UserAdd;
